import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-squares-vertical-line',
  templateUrl: './university-squares-vertical-line.component.html',
  styleUrls: ['./university-squares-vertical-line.component.scss']
})
export class UniversitySquaresVerticalLineComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
